<template>
  <div class="app-container">
    <button @click="toggleSidebar" class="toggle-btn">
      {{ isSidebarExpanded ? 'Contraer' : 'Expandir' }}
    </button>
    <div :class="['sidebar', { expanded: isSidebarExpanded }]">
      <nav>
        <ul>
          <li v-if="hasPermission('maestroGastos')">
            <router-link to="/maestroGastos" @click="toggleSidebar">Maestro viajes</router-link>
          </li>
          <li v-if="hasPermission('detallesGastos')">
            <router-link to="/detallesGastos" @click="toggleSidebar">Gastos CS</router-link>
          </li>
          <li v-if="hasPermission('detalleAlimentacionSS')">
            <router-link to="/detalleAlimentacionSS" @click="toggleSidebar">Alimentación SS</router-link>
          </li>
          <li v-if="hasPermission('detalleTransporteSS')">
            <router-link to="/detalleTransporteSS" @click="toggleSidebar">Transporte SS</router-link>
          </li>  
          <li v-if="hasPermission('autorizarGastos')">
            <router-link to="/autorizarGastos" @click="toggleSidebar">Autorizacion de Gastos</router-link>
          </li>
          <li v-if="hasPermission('accountSpent')">
            <router-link to="/accountSpent" @click="toggleSidebar">Contabilizacion de Gastos</router-link>
          </li>
          <li v-if="hasPermission('updateTables')">
            <router-link to="/updateTables" @click="toggleSidebar">Actualizacion de datos</router-link>
          </li>
          <li>
            <button type="button" @click="logout" class="logout-btn">Cerrar Sesión</button>
          </li>
        </ul>
      </nav>
    </div>
    <div :class="['main-content', { 'with-sidebar': isSidebarExpanded }]">
      <router-view />
    </div>
  </div>
</template>

<script>
import { tokenValidation, selectPermisosComponentes, logOut } from '@/api/api';

export default {
  name: 'SidebarItems',
  data() {
    return {
      isSidebarExpanded: true,
      userPermissions: [] // Aquí almacenarás los permisos del usuario
    };
  },
  created() {
    this.fetchUserPermissions();
  },
  methods: {
    async fetchUserPermissions() {
      localStorage.removeItem("dataCities");
      let correoUsuario = await tokenValidation();

      const response = await selectPermisosComponentes(correoUsuario.data);
      const data = response.data.map(permiso => (permiso));
      this.userPermissions = data; // Asigna los permisos obtenidos
    },
    hasPermission(permission) {
      // Verifica si el usuario tiene el permiso específico
      return this.userPermissions.includes(permission);
    },
    toggleSidebar() {
      this.isSidebarExpanded = !this.isSidebarExpanded;
    },
    async logout() {
      await logOut();
    },
  },
};
</script>


<style scoped>
body {
  margin: 0;
  font-family: Arial, sans-serif;
  background-color: #f2f2f2;
}

.app-container {
  min-height: 100vh;
  position: flex;
}

.toggle-btn {
  position: fixed;
  top: 1rem;
  left: 1rem;
  z-index: 1000;
  padding: 0.5rem 1rem;
  background-color: #0078d4;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.toggle-btn:hover {
  background-color: #005a9e;
}

.sidebar {
  width: 0;
  background-color: #f8f9fa;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  transition: width 0.3s, padding 0.3s;
  overflow: hidden;
  z-index: 500; /* Asegurarse de que esté por encima del contenido principal */
}

.sidebar.expanded {
  width: 250px; /* Ajusta el ancho de la barra lateral expandida */
}

.sidebar nav ul {
  list-style-type: none;
  padding: 0;
  margin-top: 60px;
  text-align: center; /* Centrar el contenido */
}

.sidebar nav ul li {
  margin-bottom: 2rem; /* Aumentar el margen inferior para más espacio entre los elementos */
}

.sidebar nav ul li a {
  text-decoration: none;
  color: #333;
  font-size: 1.5rem; /* Aumentar el tamaño de la fuente */
  display: block; /* Asegurarse de que el enlace ocupe todo el ancho del elemento li */
}


.sidebar nav ul li a.router-link-active {
  font-weight: bold;
  color: #b30000;
}

.main-content {
  padding: 1rem;
  transition: margin-left 0.3s;
  width: 100%;
  box-sizing: border-box;
  z-index: 1; /* Asegurarse de que el contenido principal esté debajo de la barra lateral */
}

/*

.main-content .with-sidebar {
  margin-left: 250px; Asegurar que el contenido principal se desplace correctamente cuando la barra lateral está expandida 
} Por si toca dezplazar el contenido
*/
@media (max-width: 600px) {
  .sidebar {
    width: 100%;
    height: 100%;
    position: fixed;
    box-shadow: none;
  }

  .sidebar.expanded {
    width: 100%;
  }

  .sidebar:not(.expanded) {
    width: 0;
    padding: 0;
  }

  .main-content {
    margin-left: 0;
    width: 100%;
  }

  .main-content.with-sidebar {
    margin-left: 0;
  }

  .toggle-btn {
    position: fixed;
    top: 1rem;
    left: 1rem;
  }
}
</style>
